import { Injectable, RESPONSE_INIT, inject } from '@angular/core';

/**
 * Used to track and report critical errors to the server
 */
@Injectable({ providedIn: 'root' })
export class CriticalErrorServiceServer {
    private response = inject(RESPONSE_INIT);

    reportCriticalError(cause?: string) {
        if (this.response?.headers instanceof Headers) {
            this.response?.headers?.set('x-critical-error', cause ?? 'true');
        }
    }
}
